import { Link, useLocation } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { useSession } from '../session'
import { LICENSE_PATH, bannerOf, fetchLicense, licenseKey } from './licenseApi'

/*
 * The license banner of every admin page (docs/platform/licensing.md §4.3):
 * expiring in ≤ 14 days, grace, inactive, nodes waiting for a seat. A center
 * without the license API (404) shows nothing.
 */
export function LicenseBanner() {
  const { user } = useSession()
  const loc = useLocation()
  const admin = user?.role === 'admin' && (loc.pathname === '/admin' || loc.pathname.startsWith('/admin/'))
  const q = useQuery({ queryKey: licenseKey(), queryFn: () => fetchLicense(), enabled: admin, refetchInterval: 5 * 60_000, retry: false, staleTime: 60_000 })
  if (!admin || !q.data) return null
  const b = bannerOf(q.data)
  if (!b) return null
  const onPage = loc.pathname === LICENSE_PATH
  return (
    <div className="mx-auto max-w-[1376px] px-4 pt-3 md:px-8">
    <div
      role="status"
      data-testid="license-banner"
      data-tone={b.tone}
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 rounded-md border px-3 py-2 text-sm ${b.tone === 'fail' ? 'border-fail/50 bg-fail/[.07]' : 'border-warn/50 bg-warn/[.07]'}`}
    >
      <span className={`font-mono text-[11px] font-semibold tracking-[.08em] ${b.tone === 'fail' ? 'text-fail' : 'text-warn'}`}>
        {b.tone === 'fail' ? '✕' : '▲'} {b.title}
      </span>
      <span className="min-w-0 flex-1 text-text-soft">{b.text}</span>
      {!onPage && (
        <Link to={LICENSE_PATH} className="text-sm font-medium underline underline-offset-2" data-testid="license-banner-link">
          License
        </Link>
      )}
    </div>
    </div>
  )
}
